import ScrollAnimation from 'react-animate-on-scroll';

const ExperienceInfo = ({ experience }) => {
  return (
    <div className="exp-flex">
      <ScrollAnimation animateIn="fadeInLeft" animateOnce={true}>
        <a href={experience.companyLink} target="_blank" rel="noreferrer" >
          <img src={experience.companyImg} alt="" className="exp-img" />
        </a>
      </ScrollAnimation>
      <ScrollAnimation className="exp-header" animateIn="fadeInRight" animateOnce={true}>
        <span className="exp-name">{experience.companyName}</span>
        <span className="exp-desc">{experience.description}</span>
      </ScrollAnimation>
    </div>
  )
}

export default ExperienceInfo;